import { render } from "./risk-view-table.vue?vue&type=template&id=038443f3&scoped=true&ts=true"
import script from "./risk-view-table.vue?vue&type=script&lang=ts"
export * from "./risk-view-table.vue?vue&type=script&lang=ts"

import "./risk-view-table.vue?vue&type=style&index=0&id=038443f3&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-038443f3"]])

export default __exports__